"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadDataLayer = void 0;
const Until_1 = require("tsbase/Utility/Timers/Until");
const getSegmentUser_1 = require("../utilities/getSegmentUser/getSegmentUser");
const accessToken_1 = require("../utilities/accessToken/accessToken");
const cookie_1 = require("../utilities/cookie/cookie");
const events_1 = require("../deltaAnalyticsSDK/enums/events");
const properties_1 = require("../deltaAnalyticsSDK/enums/properties");
const globalKeys_1 = require("../globalKeys");
function dataLayerPush(mainWindow, event, properties) {
    if (mainWindow[globalKeys_1.GlobalKeys.DeltaAnalytics]) {
        mainWindow[globalKeys_1.GlobalKeys.DeltaAnalytics].pushToDataLayer(event, properties);
    }
    else if (mainWindow['dataLayer']) {
        mainWindow['dataLayer'].push(Object.assign({ event: event }, (properties || {})));
    }
}
const loadDataLayer = (mainWindow = window, getSegmentUserFunc = getSegmentUser_1.default, getAccessTokenFunc = accessToken_1.getAccessToken, getCookieFunc = cookie_1.getCookie, maxWaitTime = 10000) => {
    (0, Until_1.Until)(() => !!mainWindow['deltaAnalytics'], undefined, maxWaitTime).then(() => {
        mainWindow['dataLayer'] = mainWindow['dataLayer'] || [];
        let data = {
            event: 'dataLayer-loaded',
            user: {
                id: null,
                loggedIn: 0,
                type: 'unknown'
            },
            gaClientId: 'unknown',
            anonymousId: 'unknown'
        };
        const gaCookie = getCookieFunc('_ga');
        const gaClientId = gaCookie ? gaCookie.slice(6) : null;
        const anonymousIDCookie = getCookieFunc('ajs_anonymous_id');
        const parsedAnonymousID = anonymousIDCookie ? anonymousIDCookie.replace(/["]+/g, '') : anonymousIDCookie;
        if (gaClientId) {
            data['gaClientId'] = gaClientId;
        }
        if (parsedAnonymousID) {
            data['anonymousId'] = parsedAnonymousID;
        }
        const accessToken = getAccessTokenFunc();
        if (accessToken === null || accessToken === void 0 ? void 0 : accessToken.userId) {
            getSegmentUserFunc(accessToken.userId)
                .then((user) => {
                var _a, _b, _c;
                let userType = 'free account';
                const userTypeArray = ['member', 'ccm'];
                if (((_a = user === null || user === void 0 ? void 0 : user.subscription) === null || _a === void 0 ? void 0 : _a.userType) && userTypeArray.includes((_b = user === null || user === void 0 ? void 0 : user.subscription) === null || _b === void 0 ? void 0 : _b.userType)) {
                    userType = user.subscription.userType;
                }
                if (user && user.subscription) {
                    data = {
                        user: {
                            id: user.guid,
                            loggedIn: 1,
                            type: userType
                        },
                        gaClientId: gaClientId,
                        anonymousId: parsedAnonymousID
                    };
                    const memberTraits = {};
                    user.subscription.level && (memberTraits['level'] = user.subscription.level);
                    user.subscription.memberType && (memberTraits['accountType'] = user.subscription.memberType);
                    user.subscription.status && (memberTraits['status'] = user.subscription.status);
                    user.subscription.memberSinceDate && (memberTraits['sinceDate'] = user.subscription.memberSinceDate);
                    user.subscription.memberStartDate && (memberTraits['startDate'] = user.subscription.memberStartDate);
                    user.subscription.expiration && (memberTraits['expirationDate'] = user.subscription.expiration);
                    user.subscription.memberCancelDate && (user.subscription.memberCancelDate);
                    Object.keys(memberTraits).length && (data['member'] = Object.assign({}, memberTraits));
                }
                const acquisitionDate = (user === null || user === void 0 ? void 0 : user.subscription) && ((_c = user.subscription) === null || _c === void 0 ? void 0 : _c.acquisitionDate);
                if (acquisitionDate && mainWindow[globalKeys_1.GlobalKeys.DeltaAnalytics]) {
                    mainWindow[globalKeys_1.GlobalKeys.DeltaAnalytics].addProperty(properties_1.Properties.Lead_AcquisitionDate, acquisitionDate);
                }
                else if (acquisitionDate) {
                    const lead = data.lead;
                    data = Object.assign(Object.assign({}, data), { lead: lead ? Object.assign(Object.assign({}, lead), { acquisitionDate }) : { acquisitionDate } });
                }
                dataLayerPush(mainWindow, events_1.Events.DataLayerLoaded, data);
                dataLayerPush(mainWindow, events_1.Events.OptimizeReady);
            })
                .catch(() => {
                dataLayerPush(mainWindow, events_1.Events.DataLayerLoaded, data);
                dataLayerPush(mainWindow, events_1.Events.OptimizeReady);
            });
        }
        else {
            dataLayerPush(mainWindow, events_1.Events.DataLayerLoaded, data);
            dataLayerPush(mainWindow, events_1.Events.OptimizeReady);
        }
    });
};
exports.loadDataLayer = loadDataLayer;
